const HeartIconFilled = () => {
  return (
    <svg
      id="HeartIconFilledId"
      className="HeartIconFilledHide"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "36px",
        height: "36px",
        borderRadius: "50rem",
        padding: "0.6rem",
        opacity: "0",
      }}
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <path d="M176,32a60,60,0,0,0-48,24A60,60,0,0,0,20,92c0,71.9,99.9,128.6,104.1,131a7.8,7.8,0,0,0,3.9,1,7.6,7.6,0,0,0,3.9-1,314.3,314.3,0,0,0,51.5-37.6C218.3,154,236,122.6,236,92A60,60,0,0,0,176,32Z"></path>
    </svg>
  );
};
export default HeartIconFilled;
